<div class="header headerdiv">
  <span>
    <h1 class="screen-title">{{ screentitle }}</h1>
  </span>
  <div *ngIf="headerDivName == 'addOrEdit'">
    <div class="button-wrapper bothbuttdiv2">
      <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
        <button class="btn btn-primary commonbutt" type="button" (click)="submitData()">
          <em class="fa fa-check"></em>&nbsp;Submit
        </button>

        <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
          <em class="fa fa-times"></em>&nbsp;Close
        </button>
      </div>
    </div>
  </div>

  <span *ngIf="Errmessage != '' && headerDivName == 'errMsgDiv'">
    <p class="errMsg">{{ Errmessage }}</p>
  </span>


</div>